export class Timer {
  private timer: NodeJS.Timeout | null = null;

  constructor(private timeout: number, private callback: () => void) {
    this.start();
  }

  private start = () => {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.timer = setTimeout(this.callback, this.timeout);
  };
  public kill = () => {
    this.timer && clearTimeout(this.timer);
    this.timer = null;
  };

  public restart = () => {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.start();
  };
}
